import * as React from "react";

const IconModalCloseInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><g fill="none" fillRule="evenodd" transform="translate(2 2)"><circle cx="14" cy="14" r="15" fill="#0A57A4" stroke="#FFF" strokeWidth="2"/><path fill="#FFF" fillRule="nonzero" d="M18.753 17.719a.75.75 0 01-1.06 1.06L14 15.06l-3.719 3.72a.75.75 0 01-1.06-1.062L12.94 14 9.22 10.253a.75.75 0 011.06-1.06L14 12.94l3.719-3.72a.75.75 0 011.06 1.062L15.06 14l3.694 3.719z"/></g></svg>;
};

export default React.memo(IconModalCloseInactive);
